<template>
  <b-row>
    <b-col cols="12" class="container min-vh-100">
      <b-row>
        <b-card class="w-100 h-100">
          <ValidationObserver ref="form">
            <b-row>
              <b-col cols="12" md="6" class="mt-3 mb-1">
                <b-form-group>
                  <label for="cNumber"
                    >ครั้งที่ <span class="text-danger">*</span></label
                  >
                  <ValidationProvider
                    rules="required"
                    name="ครั้งที่"
                    v-slot="{ errors }"
                  >
                    <b-form-input
                      id="cNumber"
                      v-model="conclusionData.cNumber"
                      placeholder="กรุณากรอก ครั้งที่ประชุม"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-col cols="11" md="5" class="mt-3 mb-1 align-item-bottom">
                <b-form-group>
                  <label for="cYear"
                    >ปี <span class="text-danger">*</span></label
                  >
                  <ValidationProvider
                    rules="required"
                    name="ปี"
                    v-slot="{ errors }"
                  >
                    <b-form-input
                      id="cYear"
                      v-model="conclusionData.cYear"
                      placeholder="กรุณากรอก ครั้งที่ประชุม"
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6" class="mt-3 mb-1">
                <b-form-group>
                  <label for="createDate"
                    >วันที่ <span class="text-danger">*</span></label
                  >
                  <ValidationProvider
                    rules="required"
                    name="วันที่"
                    v-slot="{ errors }"
                  >
                    <b-form-datepicker
                      v-model="conclusionData.cDate"
                      v-bind="languages || {}"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      locale="th"
                      :hide-header="false"
                      today-button
                      reset-button
                      close-button
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6" class="mt-3 mb-1">
                <b-form-group>
                  <label for="cTime"
                    >เวลา <span class="text-danger">*</span></label
                  >
                  <ValidationProvider
                    rules="required"
                    name="เวลา"
                    v-slot="{ errors }"
                  >
                    <b-form-timepicker
                      v-model="conclusionData.cTime"
                      locale="th"
                    ></b-form-timepicker>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-col cols="12" class="mt-3 mb-1">
                <b-form-group>
                  <label for="cPlace"
                    >สถานที่ <span class="text-danger">*</span></label
                  >
                  <ValidationProvider
                    rules="required"
                    name="cPlace"
                    v-slot="{ errors }"
                  >
                    <b-form-textarea
                      v-model="conclusionData.cPlace"
                      rows="5"
                    ></b-form-textarea>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>
              </b-col>

              <b-row
                v-for="file in this.attachFiles"
                :key="file.attachId"
                class="col-12 m-1 col-md-6"
              >
                <b-col md="10">
                  <a
                    :href="file.filePath"
                    :download="file.fileName"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-arrow-down-circle"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="8 12 12 16 16 12" />
                      <line x1="12" y1="8" x2="12" y2="16" />
                    </svg>
                    {{ file.fileName }}
                  </a>
                </b-col>
                <b-col md="2" class="d-flex justify-content-center">
                  <a
                    href="javascript:void(0)"
                    class="text-danger"
                    @click="onAttachFileDelete(file.attachId)"
                  >
                    <feather-icon icon="Trash2Icon" size="24" />
                  </a>
                </b-col>
              </b-row>

              <b-col cols="12" md="6">
                <b-form-group label="เอกสารแนบ">
                  <b-form-file
                    @change="onUploadFileChanged"
                    ref="file-input"
                    multiple
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12"></b-col>

              <b-col cols="12" md="6" class="mb-5">
                <b-form-group label="สถานะการใชข้งาน">
                  <b-form-radio-group
                    id="isActive"
                    v-model="conclusionData.isActive"
                    :options="activeOptions"
                    name="radio-is-active"
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" class="d-flex justify-content-between">
                <b-button variant="secondary" @click="onCancelBtnClicked">
                  ยกเลิก
                </b-button>
                <b-button variant="primary" @click="onSubmitBtnClicked">
                  บันทึกข้อมูล
                </b-button>
              </b-col>
            </b-row>
          </ValidationObserver>
        </b-card>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormRadioGroup,
  BFormDatepicker,
  BFormTimepicker,
  BFormFile,
} from "bootstrap-vue";

import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";

import * as conclusionStore from "@/store/api/conclusion/index.js";
import * as storeFileUpload from "@/store/api/fileUpload/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import * as lang from "vuejs-datepicker/src/locale";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    BFormDatepicker,
    BFormTimepicker,
    BFormFile,
    ValidationObserver,
    ValidationProvider,
    extend,
  },
  data() {
    return {
      conclusionData: {
        isActive: true,
      },
      attachFiles: [],
      activeOptions: [
        { text: "ใช้งาน", value: true },
        { text: "ไม่ใช้งาน", value: false },
      ],
      languages: lang.th,
    };
  },
  created() {
    const _this = this;
    if (this.$route.query.id == null) {
    } else {
      const id = this.$route.query.id;
      this.getConclusionById(id);
    }
  },
  methods: {
    getConclusionById(id) {
      const _this = this;

      conclusionStore
        .getById(id)
        .then((response) => {
          _this.conclusionData = response.data.data.conclusionData;
          _this.attachFiles = response.data.data.attachFiles;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onSubmitBtnClicked() {
      const _this = this;

      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.$swal({
          title: "ยืนยันการบันทึกข้อมูล?",
          text: "",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "บันทึก",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-primary ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            _this.conclusionData.updateBy = userData.userId();

            const params = {
              conclusionData: _this.conclusionData,
              attachFiles: _this.attachFiles,
            };

            conclusionStore
              .updateItem(params)
              .then((response) => {
                if (response.data.success === true) {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });

                  window.open(
                    _this.$router.resolve({
                      name: "Conclusion",
                    }).href,
                    "_self"
                  );
                } else {
                  _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                    title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                    variant: "danger",
                    solid: false,
                  });
                }
              })
              .catch((error) => {
                console.log("error", error);
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              });
          }
        });
      });
    },
    onCancelBtnClicked() {
      window.open(this.$router.resolve({ name: "Conclusion" }).href, "_self");
    },
    onUploadFileChanged(e) {
      const selectedFiles = e.target.files;
      if (selectedFiles === null || selectedFiles === undefined || selectedFiles.length <= 0) {
        return;
      }

      const _this = this;
      var isMissing = this.onValidateExtensionFiles(selectedFiles, null);
      if (isMissing === true) {
        return;
      }

      selectedFiles.forEach(function(value, index) {
        _this.createBase64Image(value);
      });
    },
    createBase64Image(fileObject) {
      const _this = this;
      const reader = new FileReader();

      const fileName = fileObject.name;
      const fileSize = fileObject.size;

      reader.onload = (e) => {
        const fileBase64 = e.target.result;
        console.log(
          "fileName=",
          fileName,
          "fileSize=",
          fileSize,
          "fileType=",
          _this.selected
        );
        this.$refs["file-input"].reset();

        const data = [
          {
            fileName: fileName,
            fileSize: fileSize,
            fileBase64: fileBase64,
            keyId: this.complaintId,
          },
        ];
        storeFileUpload
          .uploadFile(data)
          .then(function(response) {
            // handle success
            console.log(response);
            response.data.data.forEach(function(value, index) {
              //console.log('emit upload', value)
              //this.$emit('handleSend', id)
              _this.emitUploadFile(value);
            });
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          })
          .then(function() {
            // always executed
          });
        //console.log('base64', base64)
      };

      reader.readAsDataURL(fileObject);
    },
    emitUploadFile(file) {
      this.attachFiles = [];
      this.attachFiles.push(file);
    },
    onAttachFileDelete(id) {
      const file = this.attachFiles.find(function(value) {
        return value.attachId === id;
      });

      var filteredAry = this.attachFiles.filter((o) => o.attachId != id);

      this.attachFiles = filteredAry;
    },
    onValidateExtensionFiles(selectedFiles, section) {
      console.log(`onvalidateextensionfiles.section`, section);
      let isMissing = false;

      // เช็คว่าไฟล์ที่อัพโหลดมีสกุลไฟล์หรือไม่
      // ถ้าไม่มีให้แสดง popup แจ้งเตือน
      const arrNoExtension = Object.values(selectedFiles).filter((file) => {
        return (
          file.type === null || file.type === undefined || file.type === ""
        );
      });

      if (arrNoExtension.length > 0) {
        isMissing = true;
        this.$swal({
          html:
            "<div>ไม่สามารถอัพโหลดไฟล์ที่ไม่มีสกุลไฟล์ได้<br />กรุณาตรวจสอบไฟล์ของท่านก่อนทำการอัพโหลด</div>",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        }).then((result) => {
          try {
            this.$refs["file-input"].reset();
          } catch (ex) {
            console.log(ex);
          }
        });
      }

      return isMissing;
    },
  },
};
</script>

<style lang="scss"></style>
